// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"cf44c554","78":"dd677e67","485":"92103df3","532":"ddddacb7","835":"3b8ceb74","970":"4b2c587c"}[chunkId] + ".chunk.css";
};